export const FLW40 = {
	defaultValues: {
		height: 1000,
		width: 1000,
		windowQuantity: 1,
		ug: {
			glass3: 0.6,
			panel: 0.8
		},
		psi: {
			glass3: 0.031,
			panel: 0.03
		},
		isolation: false,
		glassThickness: 40,
		glassTypes: 2
	},
	fixedValues: {
		middleMullion: false,
		isolation: true,
		glassTypes: [
			{
				name: 'Paneele',
				value: 0
			},
			{
				name: '3-fach-Glas',
				value: 2
			}
		],
		ug3: [{value: 0.5}, {value: 0.6}, {value: 0.7}, {value: 0.8}, {value: 0.9}],
		up: [
			{
				name: 'Vakuum-Dämmkern',
				value: 0.21
			},
			{
				name: 'PU-Dämmkern',
				value: 0.63
			},
			{
				name: 'Mineralfaser-Dämmkern',
				value: 0.81
			},
			{
				name: 'XPS-Dämmkern',
				value: 0.7
			}
		],
		psi: {
			ug3: [
				{
					name: 'Thermix TX Pro:',
					value: 0.044
				}, {
					name: 'Super Spacer TriSeal / T-Spacer Premium Plus:',
					value: 0.037
				}, {
					name: 'Ultimate SwissPacer:',
					value: 0.031
				}, {
					name: 'Advance SwissPacer:',
					value: 0.042
				}, {
					name: 'Multitech:',
					value: 0.03
				}, {
					name: 'TGI-Spacer Precision:',
					value: 0.031
				}, {
					name: 'Alu:',
					value: 0.111
				}
			],
			up: [
					{ name: 'Vakuum-Dämmkern', value: 0.01},
					{ name: 'PU-Dämmkern', value: 0.02},
					{ name: 'Mineralfaser-Dämmkern', value: 0.03},
					{ name: 'XPS-Dämmkern', value: 0.02}
				]
		}
	},
	edgeTop: {
		W_m2K: 2.664,
		W_m2K_iso: 2.184,
		width: 72
	},
	edgeSide: {
		W_m2K: 2.908,
		W_m2K_iso: 2.523,
		width: 70.5
	},
	edgeBottom: {
		W_m2K: 2.518,
		W_m2K_iso: 2.032,
		width: 72
	},
	louvre: {
		W_m2K: 2.499,
		W_m2K_iso: 2.121,
		width: 60
	},
	windowWidth: {
		min: 300,
		max: 2500
	},
	windowHeight: {
		min: 340,
		max: 3000
	},
	louvreHeight: {
		min: 250,
		max: 500
	},
	edgeWidth: 40,
	gabDimensions: {
		side: 3,
		top: 4.8,
		middle: 4.8,
		bottom: 5.2
	},
	allowance: {
		width: 36,
		height: 35
	},
	area: {},

	cvReference85deg: 0.59,
	cvFactors: {cv1: 0.025, cv2: 0.025, cv3: 0.05},

	dimensionsOpenLouvre: {
		sideMullion: 43,
		profileTop: 50,
		profileBottom: 50,
		louvre: 50.8,
	},
	windLoadCalculation: {
		wl1500: [
			{
				wMax: 2414,
				hMax: 500,
				aMax: 1.21
			},
		],
		wl1750: [
			{
				wMax: 1920,
				hMax: 500,
				aMax: 0.96
			},
			{
				wMax: 2414,
				hMax: 403,
				aMax: 0.97
			},
		],
		wl2000: [
			{
				wMax: 1618,
				hMax: 500,
				aMax: 0.81
			},
			{
				wMax: 2414,
				hMax: 340,
				aMax: 0.82
			},
		],
		wl2250: [
			{
				wMax: 1412,
				hMax: 500,
				aMax: 0.71
			},
			{
				wMax: 2414,
				hMax: 297,
				aMax: 0.71
			},
		],
		wl2500: [
			{
				wMax: 1238,
				hMax: 500,
				aMax: 0.62
			},
			{
				wMax: 2414,
				hMax: 260,
				aMax: 0.63
			},
		],
		wl2750: [
			{
				wMax: 1087,
				hMax: 500,
				aMax: 0.54
			},
			{
				wMax: 2414,
				hMax: 233,
				aMax: 0.56
			},
		],
		wl3000: [
			{
				wMax: 882,
				hMax: 500,
				aMax: 0.44
			},
			{
				wMax: 2100,
				hMax: 210,
				aMax: 0.44
			},
		],
	},

};

